import { useEffect, useState } from 'react';
import { ScrollableBody } from '../Layout/ScrollableBody';
import { Spinner } from '../../controls/Spinner/Spinner';
import { getAppointment, IAppointment } from '../../API/GoMoto';
import { GoMotoComponent } from '../../API/GoMoto.types';
import { useParams } from 'react-router-dom';
import { useLocalizationDispatch } from '../../context/Localization/localization';
import { useAdditionalDealers, useKioskState, useSwitchDealer } from '../../context/Kiosk/kiosk';
import { LocalizationDispatchTypes } from '../../context/Localization/localization.types';
import { LoadAppointmentProps } from './LoadAppointment.types';

export const LoadAppointment: GoMotoComponent<LoadAppointmentProps> = ({ onLoaded }) => {
    const { dealer: { key: dealerKey } } = useKioskState();
    const params = useParams<{ apptKey: string; }>();
    const [loading, setLoading] = useState<boolean>(false);
    const localeDispatch = useLocalizationDispatch();
    const switchDealer = useSwitchDealer();
    const additionalDealers = useAdditionalDealers();
    const [appointment, setAppointment] = useState<IAppointment | undefined>(undefined);

    useEffect(() => {
        async function fetchData() {
            await getAppointment(params.apptKey ?? '')
                .then((appointment: IAppointment | null) => {
                    if (appointment) {
                        localeDispatch({ type: LocalizationDispatchTypes.SetLocale,
                            payload: appointment.locale });
                        const newDealer = additionalDealers.find((i) => i.key === appointment.dealerKey);

                        if (newDealer && newDealer.key !== dealerKey) {
                            switchDealer(newDealer);
                            setAppointment(appointment);
                        }
                        else {
                            onLoaded(appointment);
                        }
                    }
                });
        }

        if (!loading) {
            setLoading(true);
            fetchData();
        }
    }, [additionalDealers, dealerKey, loading, localeDispatch, onLoaded, params.apptKey, switchDealer]);

    useEffect(() => {
        if (appointment && appointment.dealerKey === dealerKey) {
            onLoaded(appointment);
        }
    }, [appointment, dealerKey, onLoaded]);

    return (
        <ScrollableBody
            hideAccessibilityButton
        >
            <Spinner />
        </ScrollableBody>
    );
};
